var _a;
import { createActions } from 'redux-actions';
export var resetGender = (_a = createActions('RESET_GENDER', 'SET_DEFAULT_GENDER', 'SET_GENDER'), _a.resetGender), setDefaultGender = _a.setDefaultGender, setGender = _a.setGender;
